import { Link } from "react-router-dom";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { LogIn, Settings, LayoutDashboard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
interface HeaderProps {
  isAdmin: boolean;
  showDashboardButton?: boolean;
}
export const Navigation = ({
  isAdmin,
  showDashboardButton = true
}: HeaderProps) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    supabase.auth.getSession().then(({
      data: {
        session
      }
    }) => {
      setIsLoggedIn(!!session);
    });
    const {
      data: {
        subscription
      }
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsLoggedIn(!!session);
    });
    return () => subscription.unsubscribe();
  }, []);
  return <nav className="bg-white border-b py-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
        <Link to="/">
              <img src="https://idn-static-assets.s3.ap-southeast-1.amazonaws.com/subscription/infra_logo.png" alt="IDN Logo" className="w-[214px]" />
            </Link>
          <div className="flex items-center">
            
            <NavigationMenu className="ml-8">
              <NavigationMenuList>
                <NavigationMenuItem>
                  <Link to="/" className="text-sm font-medium text-gray-700 hover:text-gray-900 px-3 py-2">Infradigital</Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/kasflow" className="text-sm font-medium text-gray-700 hover:text-gray-900 px-3 py-2">
                    Kasflow
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/pordi" className="text-sm font-medium text-gray-700 hover:text-gray-900 px-3 py-2">
                    Pordi
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/sample-links" className="text-sm font-medium text-gray-700 hover:text-gray-900 px-3 py-2">
                    Pembayaran
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>
          <div className="flex gap-4">
              {!isLoggedIn ? <Button onClick={() => navigate('/auth')} className="flex items-center gap-2" variant="outline">
                  <LogIn className="h-5 w-5" />
                  Login
                </Button> : showDashboardButton && <Button onClick={() => navigate(isAdmin ? '/management' : '/dashboard')} className="flex items-center gap-2" variant="outline">
                    {isAdmin ? <Settings className="h-5 w-5" /> : <LayoutDashboard className="h-5 w-5" />}
                    {isAdmin ? 'Admin Panel' : 'Dashboard'}
                  </Button>}
            </div>
        </div>
      </div>
    </nav>;
};